<div class="d-flex h-100">
    <div class="col-md-8 basic-panel">
        <div class="card p-3 shadow">
            <div>
                <form [formGroup]="form.formDescription">
                    <formly-form [fields]="fields.formDescription" [options]="options" [form]="form.formDescription"></formly-form>
                </form>
            </div>
            <div class="col-md-6">
                <app-versioning-select [data]="versioning"></app-versioning-select>
            </div>
            <div class="mt-2">
                <form [formGroup]="form.formGitHubLink">
                    <formly-form [fields]="fields.formGitHubLink" [options]="options" [form]="form.formGitHubLink"></formly-form>
                </form>
            </div>

            <div>
                @for(item of outputActions; track item?.name) {
                    <button class="btn  btn-accello-dark mx-2" (click)="triggerAction(item)" [disabled]="item.disabled">
                        {{ item.name }}
                        @if(item.isLoading) {
                            <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                        }
                    </button>
                }
            </div>
        </div>
    </div>

    <div class="side-panel col-md-4 px-4">
        <div class="mt-2">
            <div class="header-4"> Specifications </div>
            <form [formGroup]="form.formSpecifications">
                <formly-form [fields]="fields.formSpecifications" [options]="options" [form]="form.formSpecifications"></formly-form>
            </form>
            <div class="d-flex justify-content-center">
                <button class="btn  btn-accello-primary" [disabled]="isProcessing" (click)="onProceed()">
                    {{ isProcessing ? 'Processing' : 'Proceed' }}
                    @if(isProcessing) {
                        <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                    }
                </button>
            </div>
        </div>
    </div>
</div>